import React from 'react';

/**
 * @file TenantTabs.js
 * @description Reusable tab navigation for filtering tenants by category (Estrel SaaS, Education, Enterprise).
 */
const TenantTabs = ({ activeTab, onTabChange }) => {
    const tabs = [
        { id: "estrel", label: "Estrel SaaS", disabled: false },
        { id: "education", label: "Education", disabled: true },
        { id: "enterprise", label: "Enterprise Tenants", disabled: true }
    ];

    return (
        <div className="d-flex gap-2 mb-4">
            {tabs.map(tab => (
                <button
                    key={tab.id}
                    disabled={tab.disabled}
                    className={`btn btn-sm px-4 py-2 rounded-pill fw-medium transition-all ${activeTab === tab.id
                        ? "bg-dark text-white shadow-sm"
                        : "bg-white text-muted border"
                        } ${tab.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
                    onClick={() => !tab.disabled && onTabChange(tab.id)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

export default TenantTabs;
